<template>
  <div :id="LeftMenuId">
    <row-grid-menu>
      <menu-item v-for="(item, index) in items"
      track-by="item.icon"
      :key="item.icon"
      :labelStyle="{size: '11', color: 'black'}"
      :closePanel="closeOnClick"
      :slot="item.slot"
      :link="item.link"
      :icon="item.icon"
      :label="item.label"
      :showNumberBadge="item.showNumberBadge"
      :emit="item.emit"
      :active="item.active"
      :backGroundColor="item.backGroundColor"
      :disabled="(userIsGuest() && item.guestActive !== '1') ||
                  !$engine.user.validateAccess(item.right)"
      v-model="items[index]"
      >
      <!-- ||
     ($engine.settings.directDebit.enableInstallmentRules === '0' && item.rules === '1') ||
     item.disabledDemo === '1'
 -->
      </menu-item>
    </row-grid-menu>
  </div>
</template>

<script>
import rowGridMenu from '@/components/common/rowGridMenu.vue'
import menuItem from '@/components/common/menuItem.vue'
import requestToPayItems from '@/components/leftPanel/data/paymentsData.json'
import directPaymentItems from '@/components/leftPanel/data/directPaymentsData.json'
import directDebitItems from '@/components/leftPanel/data/directDebitData.json'
import {loadPage} from '@/helpers/routing'
import _ from 'lodash'

export default {
  props: ['type', 'serviceName'],
  components: {
    'row-grid-menu': rowGridMenu,
    'menu-item': menuItem
  },
  data: () => {
    return {
      items: [],
      closeOnClick: false,
      clearance: 0,
      LeftMenuId: ''
    }
  },
  created () {
    this.setMenuItems()
    this.closeOnClick = this.$engine.services.directPayments.filter.smartphoneStorage
    /** TLV 10/03/2020 - Gestion de l'affichage des pastilles sur le menu de gauche (version Web)
    *  Chaque 'active' est initialisé à false lors de l'appel à setMenuItems() ci-dessus.
    *  Si un des items du menu correspond au nouveau "link" (le dernier lien sur lequel l'utilisateur souhaite accéder)
    *    alors l'attribut 'active' de cet item passe à true, puis tous les autres à false (pour
    *    éviter d'avoir deux pastilles colorées en même temps).
    *  Si aucun item ne correspond au nouveau "link", on ne fait rien (et notamment on
    *    ne supprime pas la pastille déjà en place, ce qui évite de n'avoir plus aucune
    *    pastille si on créé un nouveau paiement par exemple). */
    this.$bus.on('nextLink', link => {
      let selectNewItemOnPanel = false
      this.items.forEach(item => {
        if (link.includes(item.link)) {
          selectNewItemOnPanel = true
          item.active = true
        }
      })
      if (selectNewItemOnPanel) {
        this.items.forEach(item => {
          if (!link.includes(item.link)) {
            item.active = false
          }
        })
      }
    })
    this.$bus.on('window-resize', () => {
      this.closeOnClick = this.$engine.services.directPayments.filter.smartphoneStorage
    })
  },
  watch: {
    /* TLV 10/03/2020 : Si le type d'utilisateur (particulier/entreprise) ou le service change, les items du menu de gauche sont mis à jour */
    type: function () {
      this.setMenuItems()
    },
    serviceName: function () {
      if (this.$engine.user.currentService.id != null) {
        let fromServiceIdToClearanceKey = {
          '1': 'Payments',
          '2': 'Direct Debit',
          '6': 'Direct Payments'
        }
        if (this.$engine.user.get().clearance) {
          this.clearance = this.$engine.user.get().clearance[fromServiceIdToClearanceKey[this.$engine.user.currentService.id]]
          this.LeftMenuId = this.$engine.services.getLeftMenuIdFromService(this.$engine.user.currentService.id)
        }
      }
      this.setMenuItems()
    }
  },
  methods: {
    setMenuItems () {
      if (this.$engine.user.currentService.id != null) {
        this.items = []
        let show = true
        let j = 0

        // On prélève le menu correspondant au service courant
        let fromServiceToMenu = {
          '1': requestToPayItems,
          '2': directDebitItems,
          '6': directPaymentItems
        }
        let menu = fromServiceToMenu[this.$engine.user.currentService.id].menu
        for (let i = 0; i < menu.length; i++) {
          let display = this.$i18n.t(menu[i].label)
          /* Si le type est spécifié dans le .json, on vérifie si le type courant est autorisé à voir l'item */
          if (menu[i].type.length > 0 && !menu[i].type.includes(this.type)) {
            show = false
          }
          /* Si la clearance est spécifiée dans le .json, on vérifie si la clearance courante est autorisée à voir l'item */
          if (menu[i].clear.length > 0 && !menu[i].clear.includes(this.clearance)) {
            show = false
          }
          if (show) {
            this.items[j] = _.cloneDeep(menu[i])
            this.items[j].label = display
            if (j % 2 === 0) {
              this.items[j].slot = 'leftCol'
            } else {
              this.items[j].slot = 'rightCol'
            }
            j++
          }
          show = true
        }
        this.items = this.items.map(item => { item.active = false; return item })
      }
    },
    goToInbox () {
      let that = this
      this.$engine.services.payments.filter.status = ''
      this.$engine.services.payments.filter.negotiationStatus = ''
      this.$engine.services.payments.filter.dateBegin = ''
      this.$engine.services.payments.filter.dateEnd = ''
      this.$engine.services.payments.filter.creditorOrDebtorName = ''
      this.$engine.services.payments.filter.reference = ''
      loadPage(that, {url: this.$engine.services.getUrlFromService(this.$engine.user.currentService.id) + 'inbox/'})
    },
    goToSendbox () {
      let that = this
      this.$engine.services.payments.filter.status = ''
      this.$engine.services.payments.filter.negotiationStatus = ''
      this.$engine.services.payments.filter.dateBegin = ''
      this.$engine.services.payments.filter.dateEnd = ''
      this.$engine.services.payments.filter.creditorOrDebtorName = ''
      this.$engine.services.payments.filter.reference = ''
      loadPage(that, {url: this.$engine.services.getUrlFromService(this.$engine.user.currentService.id) + 'sendbox/'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// servicesMenu.vue?7d37d5af